import { Fragment } from 'react';
import { getPitchContent } from '../utils/base';
import { BallTypeWording, BallTypeENWording, getBallTypeStyle } from '../constants/base';

const renderStatsRow = (stat, ballType, split, isPreHalf) => {
  const preHalf = (
    <Fragment>
      <td>{stat['pitches']}</td>
      <td>{stat['RHB']}</td>
      <td>{stat['LHB']}</td>
      <td>{stat['percentage']}</td>
      <td>{stat['max']}</td>
      <td>{stat['min']}</td>
      <td>{stat['avg']}</td>
    </Fragment>
  );

  const postHalf = (
    <Fragment>
      <td>{stat['ground']}</td>
      <td>{stat['lineDrive']}</td>
      <td>{stat['fly']}</td>
      <td>{stat['pop']}</td>
    </Fragment>
  );

  return (
    <tr className={ballType === 'all' ? 'total' : ''}>
      <td style={getBallTypeStyle(ballType)}>
        <span>{BallTypeWording[ballType ? ballType : 'NONE']}</span>
        <span>{BallTypeENWording[ballType ? ballType : 'NONE']}</span>
      </td>
      {!split ? (
        <Fragment>
          {preHalf}
          {postHalf}
        </Fragment>
      ) : isPreHalf ? (
        preHalf
      ) : (
        postHalf
      )}
    </tr>
  );
};

const THPreHalf = (
  <Fragment>
    <th>
      <span>總數</span>
      <span>#</span>
    </th>
    <th>
      <span>右打</span>
      <span># RHB</span>
    </th>
    <th>
      <span>左打</span>
      <span># LHB</span>
    </th>
    <th>
      <span>比例</span>
      <span>%</span>
    </th>
    <th>
      <span>球速最快</span>
      <span>Max Speed</span>
    </th>
    <th>
      <span>球速最慢</span>
      <span>Min Speed</span>
    </th>
    <th>
      <span>球速平均</span>
      <span>AVG Speed</span>
    </th>
  </Fragment>
);

const THPostHalf = (
  <Fragment>
    <th>
      <span>滾地%</span>
      <span>GB%</span>
    </th>
    <th>
      <span>平飛%</span>
      <span>LD%</span>
    </th>
    <th>
      <span>高飛%</span>
      <span>FB%</span>
    </th>
    <th>
      <span>內飛%</span>
      <span>PU%</span>
    </th>
  </Fragment>
);

export default function PitcherTable({ resolvedPerBall, stats, split }) {
  return (
    <Fragment>
      <table>
        <thead>
          <tr>
            <th>
              <span>球種</span>
              <span>Pitch Type</span>
            </th>
            {THPreHalf}
            {!split && THPostHalf}
          </tr>
        </thead>
        <tbody>
          {renderStatsRow(getPitchContent(resolvedPerBall, stats['F'], 'F'), 'F', split, true)}
          {renderStatsRow(getPitchContent(resolvedPerBall, stats['B'], 'B'), 'B', split, true)}
          {renderStatsRow(getPitchContent(resolvedPerBall, stats['C'], 'C'), 'C', split, true)}
          {renderStatsRow(getPitchContent(resolvedPerBall, stats['others'], ''), '', split, true)}
          {renderStatsRow(getPitchContent(resolvedPerBall, stats['all'], ''), 'all', split, true)}
        </tbody>
      </table>
      {split && (
        <table>
          <thead>
            <tr>
              <th>
                <span>球種</span>
                <span>Pitch Type</span>
              </th>
              {THPostHalf}
            </tr>
          </thead>
          <tbody>
            {renderStatsRow(getPitchContent(resolvedPerBall, stats['F'], 'F'), 'F', split, false)}
            {renderStatsRow(getPitchContent(resolvedPerBall, stats['B'], 'B'), 'B', split, false)}
            {renderStatsRow(getPitchContent(resolvedPerBall, stats['C'], 'C'), 'C', split, false)}
            {renderStatsRow(getPitchContent(resolvedPerBall, stats['others'], ''), '', split, false)}
            {renderStatsRow(getPitchContent(resolvedPerBall, stats['all'], ''), 'all', split, false)}
          </tbody>
        </table>
      )}
    </Fragment>
  );
}
